import { Instagram, Youtube } from "lucide-react";
import { LINKS, LOGO } from "../../data/site";
import { SmartLink } from "./primitives";

const COLS = [
  {
    title: "Work With Me",
    links: [
      { label: "Work With Me", href: LINKS.workWithMe },
      { label: "Private Sessions", href: LINKS.privateSessions },
      { label: "Massage & Bodywork", href: LINKS.massage },
      { label: "Retreats & Events", href: LINKS.retreats },
      { label: "Book a Session", href: LINKS.contact, id: "footer-book-link" },
    ],
  },
  {
    title: "Practice",
    links: [
      { label: "Classes", href: LINKS.classes },
      { label: "Practice Online", href: LINKS.practiceOnline },
      { label: "Video Library", href: LINKS.library },
      { label: "Programs", href: LINKS.programs },
      { label: "Yoga Sutras App", href: LINKS.sutras },
      { label: "Workshops & Teacher Trainings", href: LINKS.workshops },
    ],
  },
  {
    title: "About",
    links: [
      { label: "About Jake", href: LINKS.bio },
      { label: "Training & Experience", href: LINKS.training },
      { label: "Contact", href: LINKS.contact },
      { label: "Member Login", href: LINKS.login, id: "footer-member-login-link" },
    ],
  },
];

const A = ({ href, children, testid, className = "", label }) => (
  <SmartLink href={href} data-testid={testid} aria-label={label} className={className}>
    {children}
  </SmartLink>
);

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ivory px-6 pb-10 pt-20 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img src={LOGO} alt="Feeling Moved — Body, Mind, Spirit" width="1138" height="183" loading="lazy" className="h-8 w-auto" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-ink-soft">Yoga, breathwork, massage & bodywork, meditation and hypnotherapy with Jake Ferree. In San Diego and online.</p>
            <div className="mt-6 flex items-center gap-2">
              <A href={LINKS.instagram} testid="footer-instagram-link" label="Instagram (opens in a new tab)" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-ink/15 text-ink transition-colors hover:bg-ink hover:text-ivory">
                <Instagram className="h-[18px] w-[18px]" strokeWidth={1.5} />
              </A>
              <A href={LINKS.youtube} testid="footer-youtube-link" label="YouTube (opens in a new tab)" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-ink/15 text-ink transition-colors hover:bg-ink hover:text-ivory">
                <Youtube className="h-[18px] w-[18px]" strokeWidth={1.5} />
              </A>
              <A href={LINKS.venmo} testid="footer-venmo-link" className="inline-flex h-11 items-center justify-center rounded-full border border-ink/15 px-4 text-sm font-semibold text-ink transition-colors hover:bg-ink hover:text-ivory">
                Venmo<span className="sr-only"> (opens in a new tab)</span>
              </A>
            </div>
            <A href={LINKS.email} testid="footer-email-link" className="mt-4 inline-flex min-h-[44px] items-center text-sm font-semibold text-ink underline decoration-coral-ink underline-offset-[6px]">
              trainerjake@me.com
            </A>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-8">
            {COLS.map((c) => (
              <div key={c.title}>
                <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-coral-ink">{c.title}</p>
                <ul className="mt-4">
                  {c.links.map((l) => (
                    <li key={l.label}>
                      <A href={l.href} testid={l.id || `footer-${slug(c.title)}-${slug(l.label)}`} className="inline-flex min-h-[44px] items-center text-[15px] text-ink/80 transition-colors hover:text-coral-ink">
                        {l.label}
                      </A>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-ink/10 pt-6 text-xs text-ink-soft sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Jake Ferree · Feeling Moved</p>
          <div className="flex items-center gap-5">
            <A href={LINKS.privacy} testid="footer-privacy-link" className="inline-flex min-h-[44px] items-center underline decoration-ink/25 underline-offset-4 transition-colors hover:text-ink">
              App Privacy Policy
            </A>
            <p>Body · Mind · Spirit</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
